import qs from 'qs';

const addFilter = (f, v, searchString) => {
  const parsedSearch = qs.parse(searchString.substring(1));
  const filter = {};
  const filterArray = [];
  const filters = parsedSearch.filters ? JSON.parse(parsedSearch.filters) : null;
  const filterObject = {};
  filterObject[f] = v;
  if (!filters) {
    filterArray.push(filterObject);
    filter['all'] = filterArray;
    parsedSearch.filters = JSON.stringify(filter);
    parsedSearch.page = 1;
    return qs.stringify(parsedSearch);
  } else {
    filters['all'].push(filterObject);
    parsedSearch.filters = JSON.stringify(filters);
    parsedSearch.page = 1;
    return qs.stringify(parsedSearch);
  }
};

const delFilter = (f, v, searchString) => {
  const parsedSearch = qs.parse(searchString.substring(1));
  const filterObject = parsedSearch.filters ? JSON.parse(parsedSearch.filters) : {};

  for (const keys of Object.keys(filterObject['all'])) {
    for (const [key, value] of Object.entries(filterObject['all'][keys])) {
      if (key === f && value === v) {
        delete filterObject['all'][keys][key];
      }
    }
  }
  parsedSearch.filters = JSON.stringify(filterObject);
  parsedSearch.page = 1;
  return qs.stringify(parsedSearch);
};

const setAnalyticsTags = (searchString) => {
  const parsedSearch = qs.parse(searchString.substring(1));
  const filterObject = parsedSearch.filters ? JSON.parse(parsedSearch.filters) : {};

  let tags = ['search'];
  if (Object.keys(filterObject).length !== 0) {
    filterObject.all.every((item) => {
      console.log(item);
      if (Object.prototype.hasOwnProperty.call(item, 'source'))
        tags.push(item['source'].replaceAll(' ', '_'));
      return false;
    });
  }

  return { tags: tags };
};

const getFilters = (searchString) => {
  //SEARCH API filters  format
  //  "all": [
  //   { "states": ["California"] },
  //   { "world_heritage_site": ["true"] }
  // ],
  const parsedSearch = qs.parse(searchString.substring(1));
  const filterObject = parsedSearch.filters ? JSON.parse(parsedSearch.filters) : {};
  return filterObject;
};

const isFacetSelected = (f, v, searchString) => {
  const parsedSearch = qs.parse(searchString.substring(1));
  const filterObject = parsedSearch.filters ? JSON.parse(parsedSearch.filters) : {};
  if (Object.keys(filterObject).length === 0) {
    return false;
  } else {
    for (const keys of Object.keys(filterObject['all'])) {
      for (const [key, value] of Object.entries(filterObject['all'][keys])) {
        if (key === f && value === v) {
          return true;
        }
      }
    }
  }
  return false;
};

const getPage = (searchString) => {
  const parsedSearch = qs.parse(searchString.substring(1));
  const page = parsedSearch.page || 1;
  return page;
};

const changePage = (searchString, p) => {
  const parsedSearch = qs.parse(searchString.substring(1));
  parsedSearch.page = p;
  return qs.stringify(parsedSearch);
};

const changeSort = (field, direction, searchString) => {
  const parsedSearch = qs.parse(searchString.substring(1));
  parsedSearch.sort_field = field;
  parsedSearch.sort_direction = direction;
  return qs.stringify(parsedSearch);
};

const getSort = (searchString) => {
  const parsedSearch = qs.parse(searchString.substring(1));
  const sort_field = parsedSearch.sort_field || '_score';
  const sort_direction = parsedSearch.sort_direction || 'desc';
  return { sort_field, sort_direction };
};

export {
  addFilter,
  delFilter,
  getFilters,
  isFacetSelected,
  getPage,
  changePage,
  changeSort,
  getSort,
  setAnalyticsTags,
};
